/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {CoinsFountain} from "./CoinsFountain";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {SoundManager} from "../../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";

export class RomanEmpireBigWinView extends BaseView {


    private _placeHolderText: PIXI.Text;
    private _isShowing: boolean = false;
    private _dimmer: PIXI.Graphics;
    private _coinsFountain: CoinsFountain;
    private _wings: TimelineSprite[] = [];
    //private _wingsContainer: PIXI.Container;
    private _winRatioConfig: IWinRatioConfig;
    private _bigWinSpineAnim: PIXI.spine.Spine;
    private _layer: ScalableLayer;
    private _handSpine: PIXI.spine.Spine;
    private _handSpineReverse: PIXI.spine.Spine;
    private _handTl: TimelineLite;

    constructor() {
        super();
        this._coinsFountain = new CoinsFountain();
        this._layer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BIG_WIN.name);
    }

    public hideBigWinLabelOnSpinStart(): void {
        this._bigWinSpineAnim.alpha = 0;
    }

    protected initAnimations(): void {
        const bigWinLevels: number = 3;
        this._dimmer = new PIXI.Graphics();
        this._dimmer.alpha = 0;
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.FOUNTAIN.name).addChildAt(this._dimmer, 0);

        this._bigWinSpineAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("bigWinLevels"));
        this._bigWinSpineAnim.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X, GameConfig.instance.GAME_HEIGHT * 0.27);

        this._handSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("hand_animation"));
        this._handSpineReverse = new PIXI.spine.Spine(GameResources.getSpineAsset("hand_animation"));
        this._handSpineReverse.scale.set(-1, 1);
        this._handSpine.scale.set(1, 1);
        this._handSpineReverse.alpha = 0;
        this._handSpine.alpha = 0;
        this._layer.addChildAt(this._bigWinSpineAnim, 0);
        this._layer.addChildAt(this._handSpineReverse, 0);
        this._layer.addChildAt(this._handSpine, 0);
        this._bigWinSpineAnim.alpha = 0;

    }

    public getBigWinLevelTimeline(level: number, duration: number, isEnd: boolean = false): TimelineLite {
        let levelStr = "";
        if (level === 0) {
            levelStr = "bigwin";
        } else if (level === 1) {
            levelStr = "megawin";
        } else if (level === 2) {
            levelStr = "supermegawin";
        }
        const tl: TimelineLite = new TimelineLite();
        const startAnim: SpineTween = new SpineTween(this._bigWinSpineAnim, 0, `${levelStr}_start`, 0);
        const loopAnim: SpineTween = new SpineTween(this._bigWinSpineAnim, 0, `${levelStr}_loop`, -1);

        if (isEnd) {
            const endAnim: SpineTween = new SpineTween(this._bigWinSpineAnim, 0, `${levelStr}_end`, 0);
            tl.add(TweenLite.to(this._bigWinSpineAnim, 0.001, {alpha: 1}));
            tl.add(endAnim);
            tl.add(() => {
                TweenLite.to(this._handSpine, 0.4, {alpha: 0});
                TweenLite.to(this._handSpineReverse, 0.4, {alpha: 0});
            }, "-=0.25");
            return tl;
        }

        const handLevelAnim: SpineTween = new SpineTween(this._handSpine, 0, "hand_level", 0);
        const handLevelAnimReverse: SpineTween = new SpineTween(this._handSpineReverse, 0, "hand_level", 0);
        if (level == 0) {
            tl.add(() => {
                handLevelAnim;
                handLevelAnimReverse;
                TweenLite.to(this._handSpine, 0.001, {alpha: 1});
                TweenLite.to(this._handSpineReverse, 0.001, {alpha: 1});
            });
        } else {
            tl.add(() => {
                this._handSpine.state.setAnimation(0, "hand_level", false);
                this._handSpineReverse.state.setAnimation(0, "hand_level", false);
            })
        }

        tl.add(() => {
            this._handSpine.state.setAnimation(0, "hand_switch", true);
            this._handSpineReverse.state.setAnimation(0, "hand_switch", true);
        }, handLevelAnim.duration());

        tl.add(TweenLite.to(this._bigWinSpineAnim, 0.001, {alpha: 1}), 0);
        tl.add(startAnim, 0);
        tl.add(loopAnim, startAnim.totalDuration());
        //tl.add(endAnim, duration - endAnim.totalDuration());
        //level === 2 && tl.add(endAnim, duration - endAnim.totalDuration());
        return tl;
    }

    protected onResize(resizeData: IResizeData): void {
        if (!this._isShowing) {
            this._isResizeDirty = true;
            return;
        }
        const screenWidth: number = Math.ceil(resizeData.width / this._layer.scale.x);
        const screenHeight: number = Math.ceil(resizeData.height / this._layer.scale.y);
        const leftOffset: number = Math.floor(-this._layer.x / this._layer.scale.x);
        const topOffset: number = Math.floor(-this._layer.y / this._layer.scale.y);

        this._dimmer.clear();
        this._dimmer.beginFill(0x000000, 0.8);
        this._dimmer.drawRect(leftOffset, topOffset, screenWidth, screenHeight);
        this._winRatioConfig && this._bigWinSpineAnim.scale.set(this.getAnimationScale(this._winRatioConfig));
        if (resizeData.orientation === Orientation.LANDSCAPE) {
            this._handSpine.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X - RomanEmpireGameConfig.instance.REEL_AREA_WIDTH * 0.5, RomanEmpireGameConfig.instance.REEL_AREA_POS_Y +
                RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT * 0.8);
            this._handSpineReverse.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X + RomanEmpireGameConfig.instance.REEL_AREA_WIDTH * 0.5, RomanEmpireGameConfig.instance.REEL_AREA_POS_Y +
                RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT * 0.8);
        } else {
            this._handSpine.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X - RomanEmpireGameConfig.instance.REEL_AREA_WIDTH * 0.30, RomanEmpireGameConfig.instance.REEL_AREA_POS_Y +
                RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT);
            this._handSpineReverse.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X + RomanEmpireGameConfig.instance.REEL_AREA_WIDTH * 0.30, RomanEmpireGameConfig.instance.REEL_AREA_POS_Y +
                RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT);
        }

        this._isResizeDirty = false;
    }

    private playLevelSound(level: number) {
        if (level > 0) {
            SoundManager.stopSound(RomanEmpireSoundConfig.instance.BIG_WIN_LEVEL + level);
        }
        SoundManager.playSound(RomanEmpireSoundConfig.instance.BIG_WIN_LEVEL + (level + 1));
    }

    public getBigWinLevelAnimation(winRatioConfig: IWinRatioConfig, level: number): Timeline {
        this._isShowing = true;
        if (this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        this._winRatioConfig = winRatioConfig;
        const timeline: TimelineLite = new TimelineLite();
        this._bigWinSpineAnim.scale.set(this.getAnimationScale(winRatioConfig));
        const duration: number = 0.1;
        timeline.add([
            () => {
                this._coinsFountain.startFountain(level);
                this.playLevelSound(level);
            },
            this.getBigWinLevelTimeline(level, winRatioConfig.duration),
            TweenLite.to(this._dimmer, duration, {alpha: 1}),
            TweenLite.to(() => {
            }, winRatioConfig.duration, {}) // this tween has to be added to increase the big win count up duration(similar tween is applied in other games)
        ]);
        return timeline;
    }

    private getAnimationScale(winRatioConfig: IWinRatioConfig): number {
        switch (winRatioConfig.text) {
            case "Big Win":
                return 1;
                break;
            case "Mega Win":
                return this._resizeData.orientation === Orientation.LANDSCAPE ? 1 : 0.8;
                break;
            case "Super Mega Win":
                return this._resizeData.orientation === Orientation.LANDSCAPE ? 1 : 0.7;
                break;
        }
        return 0;
    }

    /**
     * To change the big win level animation
     * @param text
     */
    private updateBigWinLevelAnimation(text: string): void {
        this._placeHolderText.text = text;
        this._isShowing = true;
    }

    public playEndingAnimation(endLevel: number, isAborted: boolean = false, isReSpin: boolean = false): void {
        let levelStr: string = "";
        let spinescale;
        if (endLevel === 0) {
            levelStr = "bigwin";
            spinescale = 1;
        } else if (endLevel === 1) {
            levelStr = "megawin";
            spinescale = this._resizeData.orientation === Orientation.LANDSCAPE ? 1 : 0.8
        } else if (endLevel === 2) {
            levelStr = "supermegawin";
            spinescale = this._resizeData.orientation === Orientation.LANDSCAPE ? 1 : 0.7;
        }
        this._bigWinSpineAnim.scale.set(spinescale);
        const timeline: TimelineLite = new TimelineLite();
        if (isAborted) {
            //const loopAnim: SpineTween = new SpineTween(this._bigWinSpineAnim, 0, `${levelStr}_loop`, -1);
        }
        timeline.add(
            () => {
                this._coinsFountain.stopFountain();
                SoundManager.stopSound(RomanEmpireSoundConfig.instance.BIG_WIN_LEVEL + "1");
                SoundManager.stopSound(RomanEmpireSoundConfig.instance.BIG_WIN_LEVEL + "2");
                SoundManager.stopSound(RomanEmpireSoundConfig.instance.BIG_WIN_LEVEL + "3");
                SoundManager.playSound(RomanEmpireSoundConfig.instance.BIG_WIN_ENDS);
                SoundManager.fadeSound(isReSpin ? RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS : RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 2000, 1)
                TweenLite.fromTo(this._dimmer, 0.4, {alpha: 0.8}, {alpha: 0, delay: 0.5});
            },
            this.getBigWinLevelTimeline(endLevel, 0.3, true)
        );
        timeline.add([
            TweenLite.fromTo(this._bigWinSpineAnim, 0.4, {alpha: 1}, {alpha: 0}),
        ], 0.5);
        timeline.add(() => this._isShowing = false);
        timeline.play();
    }
}